import { clearCookie } from '@/utils/cookies'
import {
  MO_ACCESS_TOKEN_COOKIE_NAME,
  MO_REFRESH_TOKEN_COOKIE_NAME,
  MO_IS_AUTH_COOKIE_NAME,
  SELECTED_USER_ROLE_COOKIE_NAME,
  SELECTED_MEDICAL_CHAIN_COOKIE_NAME,
} from '@/const'
import { useConfirmDialog } from '@/composables/useConfirm'
import { i18n } from '@/i18n'

import { logoutResource } from '@/services/auth.service'

const { t: $t } = i18n.global

export default async function useLogout() {
  return new Promise((resolve, reject) => {
    logoutResource.execute().then(
      () => {
        clearCookie(MO_ACCESS_TOKEN_COOKIE_NAME)
        clearCookie(MO_REFRESH_TOKEN_COOKIE_NAME)
        clearCookie(MO_IS_AUTH_COOKIE_NAME)
        // clearCookie(SELECTED_USER_ROLE_COOKIE_NAME)
        // clearCookie(SELECTED_MEDICAL_CHAIN_COOKIE_NAME)

        resolve(true)
      },
      (err) => {
        reject(err)
      },
    )
  })
}
export const logoutAndRedirect = async () => {
  try {
    await useLogout()
    window.location.href = window.login_url
  } catch (e) {
    console.warn(e)
  }
}

export function useConfirmLogout() {
  return async () => {
    const question = $t('Are you sure you want to log out?')
    try {
      await useConfirmDialog({
        question,
        cancelText: $t('Cancel logout'),
        approvalText: $t('Confirm logout'),
      })
      await logoutAndRedirect()
    } catch (e) {
      console.warn(e)
    }
  }
}
